var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8621 4.52517L14.2657 0.166129C14.0832 -0.0553763 13.7897 -0.0553763 13.6071 0.166129C13.4246 0.387634 13.4246 0.743705 13.6071 0.96521L16.4084 4.36414H0.467923C0.20935 4.36414 0 4.61816 0 4.93189C0 5.24638 0.20935 5.5004 0.467923 5.5004H16.4078L13.6065 8.89026C13.424 9.11176 13.424 9.46783 13.6065 9.68934C13.6981 9.80047 13.8159 9.85565 13.938 9.85565C14.0595 9.85565 14.1779 9.80047 14.2695 9.68934L17.8664 5.32501C18.0452 5.10728 18.0452 4.74743 17.8621 4.52517Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow_1.b0485bbe656ac66f5b11968c41c7d1ff.svg";
export { ForwardRef as ReactComponent };